import React from 'react'
import Header from './Header'
import Footer from './Footer'

function Clientdetails2() {
  return (
    <div>
        <Header/>
        <Footer/>
    </div>
  )
}

export default Clientdetails2